// Generated by purs version 0.15.15
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Restaumatic_I18n_Types from "../Restaumatic.I18n.Types/index.js";
var hasDefaultValueUnit = {
    defaultValue: Data_Unit.unit
};
var hasDefaultValueTranslated = {
    defaultValue: Restaumatic_I18n_Types.emptyTranslated
};
var hasDefaultValueString = {
    defaultValue: ""
};
var hasDefaultValueMaybe = /* #__PURE__ */ (function () {
    return {
        defaultValue: Data_Maybe.Nothing.value
    };
})();
var hasDefaultValueMap = {
    defaultValue: Data_Map_Internal.empty
};
var hasDefaultValueBoolean = {
    defaultValue: false
};
var hasDefaultValueArray = {
    defaultValue: [  ]
};
var defaultValue = function (dict) {
    return dict.defaultValue;
};
var hasDefaultValueMap1 = {
    defaultValue: /* #__PURE__ */ Data_Newtype.wrap()(/* #__PURE__ */ defaultValue(hasDefaultValueMap))
};
export {
    defaultValue,
    hasDefaultValueUnit,
    hasDefaultValueBoolean,
    hasDefaultValueString,
    hasDefaultValueMaybe,
    hasDefaultValueArray,
    hasDefaultValueMap,
    hasDefaultValueMap1,
    hasDefaultValueTranslated
};
